module.exports = __webpack_public_path__ + "static/media/img.preview4.ssr.77fbec1c.svg";